// SVG 파일들을 URL로 import
import calendarIcon from './calendar.svg?url';
import checkboxIcon from './checkbox.svg?url';
import chevronDownIcon from './chevron-down.svg?url';
import chevronLeftIcon from './chevron-left.svg?url';
import chevronUpIcon from './chevron-up.svg?url';
import grayStarIcon from './gray-star.svg?url';
import pencilIcon from './pencil.svg?url';
import personIcon from './person.svg?url';
import plusIcon from './plus.svg?url';
import xIcon from './x.svg?url';
import yellowStarIcon from './yellow-star.svg?url';

// 모든 아이콘을 하나의 객체로 export
export const icons = {
  calendar: calendarIcon,
  checkbox: checkboxIcon,
  chevronDown: chevronDownIcon,
  chevronLeft: chevronLeftIcon,
  chevronUp: chevronUpIcon,
  grayStar: grayStarIcon,
  pencil: pencilIcon,
  person: personIcon,
  plus: plusIcon,
  x: xIcon,
  yellowStar: yellowStarIcon,
};

// 개별 export도 제공
export {
  calendarIcon,
  checkboxIcon,
  chevronDownIcon,
  chevronLeftIcon,
  chevronUpIcon,
  grayStarIcon,
  pencilIcon,
  personIcon,
  plusIcon,
  xIcon,
  yellowStarIcon,
};

// CSS에서 사용할 수 있도록 CSS 변수 설정
export const setupCSSVariables = () => {
  const root = document.documentElement;
  root.style.setProperty('--icon-calendar', `url("${calendarIcon}")`);
  root.style.setProperty('--icon-checkbox', `url("${checkboxIcon}")`);
  root.style.setProperty('--icon-chevron-down', `url("${chevronDownIcon}")`);
}; 